import React from "react";

// Steady Path Funding — Wordmark logo matching the LinkedIn brand hybrid:
// serif italic "Steady Path" over serif regular "Funding" (see /branding/logo-final.svg).
export const Logo = ({ className = "", compact = false }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Mark: ascending bars, cream + gold (matches LinkedIn logo bar-chart mark) */}
      <svg
        width="30"
        height="30"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="1" y="24" width="7" height="7" fill="var(--gold)" />
        <rect x="9" y="17" width="7" height="14" fill="var(--bone)" />
        <rect x="17" y="10" width="7" height="21" fill="var(--bone)" />
        <rect x="25" y="3" width="6" height="28" fill="var(--gold)" />
      </svg>
      {!compact && (
        <div className="leading-[1.05]">
          <div className="font-serif italic text-[15px] tracking-tight text-[color:var(--bone)]">
            Steady Path
          </div>
          <div className="font-serif text-[15px] tracking-tight text-[color:var(--bone)]">
            Funding
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
